import { useEffect, useState } from 'react';

// Turns true `delayMs` after `trigger` becomes true (e.g. showing a brief loader
// before an onboarding popup appears); resets back to false as soon as `trigger`
// goes false again.
export function useDelayedFlag(trigger: boolean, delayMs: number = 2000): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!trigger) {
      setReady(false);
      return;
    }
    const timer = setTimeout(() => setReady(true), delayMs);
    return () => clearTimeout(timer);
  }, [trigger, delayMs]);

  return ready;
}
